enum ServiceType {
    Preschool,
    Tution,
    Sports,
    Fitness,
    Rentals,
    CableTV,
    Creche,
    Other,
}
enum VerificatioStatus {
    NotVerified,
    KYCVerified,
}

enum BillingType {
    Upfront,
    EndOfCycle,
}
enum PaymentType {
    cash,
    online,
}
export enum PaymentStatus {
    Pending = "Pending",
    Failed = "Failed",
    Partial = "Partial",
    Paid = "Paid",
    Expired = "Expired",
    Settled = "Settled",
    SettlementHold = "SettlementHold",
    TransferFailed = "TransferFailed",
    TransferSucceeded = "TransferSucceeded",
}
enum Usertype {
    PROVIDER,
    EMPLOYEE,
    CUSTOMER,
}
enum AuthNProviderType {
    PHONE,
    EMAIL,
    GOOGLE,
    APPLE,
    MICROSOFT,
}
enum DeliveryCycle {
    DAILY,
    WEEKLY,
    FORTNIGHTLY,
    MONTHLY,
}
enum Week {
    MON,
    TUE,
    WED,
    THU,
    FRI,
    SAT,
    SUN,
}
enum OfferType {
    OneTime,
    Cycle,
}
enum SubStatus {
    Active,
    Paused,
    InActive,
    Expired,
    Terminated,
    TerminationDue,
}
enum GroupMsgTemplates {
    PaymentReminder,
    NoClassToday,
    Welcome,
}
enum AttendanceStatus {
    NotMarked,
    Absent,
    Present,
}
enum Callbackaction {
    Add,
    Subtract,
    TextChange,
}
enum WhatsAppStatus {
    submitted,
    failed,
}
enum InvoiceState {
    InvoiceGenerated,
    InvoiceNeeded,
    InvoicePaused,
}
enum BusinessType {
    llp,
    ngo,
    other,
    individual,
    partnership,
    proprietorship,
    public_limited,
    private_limited,
    not_yet_registered,
    educational_institutes,
}
enum TradeTypes {
    SportsCoach,
    Creche,
    FitnessTrainer,
    Physiotherapist,
    LifeCoach,
}
enum BankAccountTypes {
    Saving,
    Current,
}

enum verifiedLeadStatus {

    "Interested",
    "Not Interested",
}

enum daysOfWeek {
    Mon,
    Tue,
    Wed,
    Thu,
    Fri,
    Sat,
    Sun,
}

export enum SubscriptionType {
    MultiMonth = "MultiMonth",
    Count = "Count",
    Monthly = "Monthly",
    Hours = "Hours",
}

export enum BillingCycle {
    Quarterly = "Quarterly",
    Semester = "Semester",
    Annual = "Annual",
    FlexibleMonthly = "FlexibleMonthly",
    Count = "Count",

}

export enum PageName {
    Inflow = "Inflow",
    ExportHistory = "ExportHistory",
    Events = "Events",
    Statistics = "Statistics",
    Subscription = "Subscription",
    Ledger = "Ledger",
}

export enum ActionType {
    addBankAccount = "addBankAccount",
    raiseInvoice = "raiseInvoice",
    raiseInvoiceIndividual = "raiseInvoiceIndividual",
    raiseInvoiceBulk = "raiseInvoiceBulk",
    editOrder = "editOrder",
    cancelOrder = "cancelOrder",
    editLiveSubscriptionPrice = "editLiveSubscriptionPrice",
    terminateLiveSubscription = "terminateLiveSubscription",
    markPaid = "markPaid",
    deleteBatch = "deleteSubscription",
}

